module.exports = __webpack_public_path__ + "static/media/logo_horizontal.fe556c79.png";